import { defaultLocale } from '@wix/wix-events-commons-statics';
import { getDay, getMonth, getWeekDay, getYearMonthDay } from './formatter';
import { getDiffInHours, getMomentDate, getUtcOffset, now } from './date';
import { getFormattedFullDate, getFormattedShortStartDate, getFormattedStartDate, getFormattedStartTime, } from './event-selectors';
var getDaysLeft = function (event) {
    var _a = event.scheduling.config, timeZoneId = _a.timeZoneId, startDate = _a.startDate;
    var nowMoment = now(timeZoneId);
    var start = getMomentDate(startDate, timeZoneId);
    var hours = Math.floor(getDiffInHours(start, nowMoment));
    var days = Math.ceil((hours - start.hour()) / 24);
    return days < 0 ? 0 : days;
};
export var eventsToDates = function (eventsList, fullLocale) {
    if (fullLocale === void 0) { fullLocale = defaultLocale; }
    return eventsList
        .filter(function (event) { return event; })
        .reduce(function (state, event) {
        var _a = event.scheduling.config, startDate = _a.startDate, timeZoneId = _a.timeZoneId;
        var information = {
            utcOffset: getUtcOffset(startDate, timeZoneId),
            monthDay: getDay(startDate, timeZoneId, fullLocale),
            weekDay: getWeekDay(startDate, timeZoneId, fullLocale),
            month: getMonth(startDate, timeZoneId, fullLocale),
            fullDate: getFormattedFullDate(event, fullLocale),
            shortStartDate: getFormattedShortStartDate(event, fullLocale),
            startDate: getFormattedStartDate(event, fullLocale),
            startTime: getFormattedStartTime(event, fullLocale),
            daysLeft: getDaysLeft(event),
            day: getDay(startDate, timeZoneId, fullLocale),
        };
        state[event.id] = information;
        return state;
    }, {});
};
export var ordersToDates = function (orders, locale) {
    if (orders === void 0) { orders = []; }
    if (locale === void 0) { locale = defaultLocale; }
    return orders.reduce(function (acc, order) {
        acc[order.orderNumber] = getYearMonthDay(order.created, '', locale);
        return acc;
    }, {});
};
//# sourceMappingURL=events-dates.js.map